import React, { useState, useEffect } from "react";
import { Button, Select, Spin, message } from "antd";
import { createPackage, getAllPackages, updateException } from "../api";
import { ExceptionStatus } from "../ExceptionDrawer";
import Hide from "../../components/Hide";

const { Option } = Select;

const PackageComponent = ({ exception, onClose, onResolved }) => {
    const [packageName, setPackageName] = useState(null);
    const [procuringEntityId, setProcuringEntityId] = useState(null);
    const [showSelect, setShowSelect] = useState(false);
    const [packages, setPackages] = useState([]);
    const [selectedAliasId, setSelectedAliasId] = useState(null);
    const [loading, setLoading] = useState(false); 

    useEffect(() => {
        const extractPackageDetails = () => {
            setPackageName(exception?.unknown_infomation);
            setProcuringEntityId(exception?.procuring_entity_id);
        };

        if (exception && exception.description) {
            extractPackageDetails();
        }

        const fetchPackages = async () => {
            setLoading(true); 
            try {
                
                const packagesAll = (await getAllPackages({ procring_entity_id: procuringEntityId }))?.data;
            
                setPackages(Array.isArray(packagesAll) ? packagesAll : []);
            } catch (error) {
                console.error('Failed to fetch packages', error);
            } finally {
                setLoading(false); 
            }
        };
        if(!!procuringEntityId) {
            
            fetchPackages();
        }
        console.log(exception);
       
    }, [exception, procuringEntityId]);

    const handleMarkAsNew = async () => {
        setLoading(true); 
        if (packageName && procuringEntityId) {
            if (exception.status === 'pending') {
                try {
                    await createPackage({ name: packageName, procuring_entity_id: procuringEntityId });
                    await updateException(exception.id);
                    console.log(`Package "${packageName}" created successfully with procuring entity ID: ${procuringEntityId}.`);
                    message.success('Package created');
                    try { if (typeof onResolved === 'function') await onResolved(); } catch {}
                    onClose(); 
                } catch (error) {
                    console.error(`Failed to create package "${packageName}".`, error);
                    message.error('Failed to create package');
                    try { if (typeof onResolved === 'function') await onResolved(); } catch {}
                    onClose();
                } finally {
                    setLoading(false); 
                }
            } else {
                console.warn("Exception already resolved.");
                try { if (typeof onResolved === 'function') await onResolved(); } catch {}
                onClose();
            }
        } else {
            console.warn("Package name or procuring entity ID not found.");
            setLoading(false);
            onClose();
        }
    };

    const handleMarkAsAliasFor = () => {
        setShowSelect(true);
    };

    const handlePackageSelect = (value) => {
        setSelectedAliasId(value ?? null);
    };

    const handleSaveAlias = async () => {
        if (!selectedAliasId) return;
        setLoading(true);
        if (exception.status === 'pending') {
            try {
                await createPackage({ name: packageName, alias_for: selectedAliasId, procuring_entity_id: procuringEntityId });
                await updateException(exception.id);
                console.log(`Package "${packageName}" set as alias for package with ID: ${selectedAliasId}`);
                message.success('Alias saved');
                try { if (typeof onResolved === 'function') await onResolved(); } catch {}
                onClose();
            } catch (error) {
                console.error(`Failed to update alias for package with ID: ${selectedAliasId}`, error);
                message.error('Failed to save alias');
                try { if (typeof onResolved === 'function') await onResolved(); } catch {}
                onClose();
            } finally {
                setLoading(false);
            }
        } else {
            console.warn("Exception already resolved.");
            try { if (typeof onResolved === 'function') await onResolved(); } catch {}
            onClose();
        }
    };

    return (
        <div style={{ marginTop: 20 }}>
            <Hide condition={exception.status === ExceptionStatus.RESOLVED}>
                <Spin spinning={loading} tip="Processing...">
                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
                        <Button 
                            type="primary" 
                            onClick={handleMarkAsNew}
                            disabled={loading}
                            loading={loading}
                        >
                            Mark as New
                        </Button>
                        <Button 
                            type="default" 
                            onClick={handleMarkAsAliasFor}
                            disabled={loading}
                        >
                            Mark as Alias For
                        </Button>
                        {showSelect && (
                            <>
                                <div style={{ fontSize: 12, color: '#666' }}>
                                    {packageName ? `Select an existing package to alias "${packageName}" to.` : 'Select an existing package to alias.'}
                                </div>
                                <Select
                                    style={{ minWidth: 220 }}
                                    placeholder="Select a package"
                                    onChange={handlePackageSelect}
                                    disabled={loading}
                                    value={selectedAliasId ?? undefined}
                                >
                                    {packages.map((packageItem) => (
                                        <Option key={packageItem.id} value={packageItem.id}>
                                            {packageItem.name}
                                        </Option>
                                    ))}
                                </Select>
                                <Button
                                    type="primary"
                                    onClick={handleSaveAlias}
                                    disabled={loading || !selectedAliasId}
                                    loading={loading}
                                >
                                    Save
                                </Button>
                            </>
                        )}
                    </div>
                </Spin>
            </Hide>
        </div>
    );
};

export default PackageComponent;
